module.exports = __webpack_public_path__ + "media/bootstrap-icons/eject-fb90eb8b.svg";